<template>
    <div v-loading="loading">
        <el-form-item label="Predefined">
            <el-select value="" v-on:input="updateCannedMsg">
                <el-option
                    :key="option.id"
                    v-for="option in cannedMessages"
                    :label="option.name"
                    :value="option.id"
                ></el-option>
            </el-select>
        </el-form-item>

        <el-form-item label="Recipient">
            <el-input v-model="message.email"></el-input>
        </el-form-item>

        <el-form-item label="Subject">
            <el-input v-model="message.subject"></el-input>
        </el-form-item>

        <el-form-item label="Message">
            <wysiwyg v-model="message.content"></wysiwyg>
        </el-form-item>

        <el-form-item>
            <el-button type="primary" @click="send">Send</el-button>
        </el-form-item>
    </div>
</template>

<script>
import api from '../libs/api';

export default {
    computed: {
        api() {
            return this.$resource(
                this.rootConfig.endPoint + '/canned_messages/{id}',
                {},
                {},
                { headers: this.rootConfig.headers }
            );
        },
        apiTranslated() {
            return this.$resource(
                this.rootConfig.endPoint + '/translations?per_page=500',
                {},
                {},
                { headers: this.rootConfig.headers }
            );
        },
    },
    data() {
        return {
            cannedMessages: [],
            loading: false,
            message: {
                subject: '',
                content: '',
                order_id: '',
                email: '',
                language: '',
            },
        };
    },
    watch: {
        model() {
            this.message.email = this.model.email;
            this.message.order_id = this.model.id;
        },
    },
    props: ['model', 'config', 'rootConfig'],
    created() {
        this.api.get().then((res) => {
            this.cannedMessages = res.data;

            this.apiTranslated.get().then((res) => {
                const translatedMessages = res.data;

                if (translatedMessages) {
                    const content = translatedMessages.filter(
                        (tm) => tm.key === 'content'
                    );
                    const subjectMessages = translatedMessages.filter(
                        (tm) => tm.key === 'subject'
                    );

                    const data = content.filter((co) =>
                        subjectMessages.filter((sm) => {
                            if (
                                sm.foreign_id === co.foreign_id &&
                                sm.language === co.language
                            ) {
                                co.subject = sm.body;
                                const message = this.cannedMessages.filter(
                                    (cm) => cm.id === co.foreign_id
                                );
                                co.name =
                                    message.length > 0
                                        ? `${co.language.toUpperCase()}: ${
                                              message[0].name
                                          }`
                                        : co.id;
                            }
                        })
                    );

                    data.forEach((element) => {
                        this.cannedMessages.push({
                            content: element.body,
                            name: element.name,
                            subject: element.subject,
                            id: element.id,
                            language: element.language,
                        });
                    });
                }
            });
        });
    },
    methods: {
        send() {
            let mailApi = this.$resource(
                this.rootConfig.endPoint + '/mails/{id}',
                {},
                {},
                { headers: this.rootConfig.headers }
            );

            this.loading = true;

            mailApi
                .save(this.message)
                .then((res) => {
                    this.$message('Message sent successfully');
                    this.loading = false;
                })
                .catch((res) => {
                    api.errorHandler(res);
                    this.loading = false;
                });
        },
        updateCannedMsg(val) {
            let msgs = this.cannedMessages.filter((item) => {
                return item.id === val;
            });

            if (msgs.length > 0) {
                this.message.content = msgs[0].content;
                this.message.subject = msgs[0].subject;
                this.message.language = msgs[0].language;
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// Messages.vue?7d6af7ef